import { ErrorOutlineRounded } from '@mui/icons-material'
import { yandexMap } from 'feature/addresses/redux/addressCreateSelector'
import { debouncedGetSuggestsQueryByCoords } from 'feature/DaData/getSuggestsQueryByCoords'
import { InformationCard } from 'feature/informationCard'
import { TSuggest } from 'feature/registration/types'
import { ServiceCenter } from 'feature/serviceCenters/components/ServiceCenter/ServiceCenter'
import { MarkIconType } from 'feature/YandexMap/types'
import { useEffect, useState } from 'react'
import { useSearchParams, useParams } from 'react-router-dom'
import { Loading } from 'router/Loading'
import { useActions, useAppSelector } from 'store/hooks'

// детальная страница сц
export function ServiceCenterDetail() {
  const { userGeo } = useAppSelector(yandexMap)

  const {
    setStaticMarkIcon,
    clearMap,
    setStaticMarkCoords,
    setUserGeo,
    setServiceMarks,
  } = useActions()
  const [searchParams] = useSearchParams()
  const params = useParams()
  const searchServiceType = params.id
  const [isGeoError, setIsGeoError] = useState(false)

  const latitude = searchParams.get('geo-lat')
  const longitude = searchParams.get('geo-lon')
  const isCoordExist = latitude && longitude
  const requestServiceBody = isCoordExist
    ? { coordinates: { latitude, longitude } }
    : { id: searchServiceType }

  useEffect(() => {
    clearMap()
    setStaticMarkIcon(MarkIconType.redShop)
    setServiceMarks(null)

    if (searchServiceType === 'geo-address') {
      setUserGeo({ address: null })
      if (latitude && longitude)
        debouncedGetSuggestsQueryByCoords(latitude, longitude).then(res => {
          if (res?.data.length === 0) {
            setUserGeo({ address: null })
            setIsGeoError(true)
            return
          }
          const address = res?.data[0] as TSuggest
          if (address) {
            setUserGeo({ address: address })
          }
        })
    }
    return () => {
      setStaticMarkCoords(null)
    }
  }, [])

  if (latitude === 'null' || longitude === 'null' || isGeoError) {
    return (
      <InformationCard
        title='Сервисный центр не найден'
        subtitle={`Вероятно, мы не смогли определить координаты вашего адреса. 
        Пожалуйста, попробуйте ввести адрес, ближайший к указанному ранее`}
        Icon={<ErrorOutlineRounded fontSize='large' color='primary' />}
        link='/'
        linkText='На главную'
      />
    )
  }

  if (
    !userGeo.address &&
    (searchServiceType === 'geo-address' ||
      searchServiceType === 'user-address')
  ) {
    return <Loading />
  }

  return (
    <ServiceCenter id={searchServiceType} requestBody={requestServiceBody} />
  )
}
